import {css} from '@emotion/react'

const cssToolBar = css({
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    backgroundColor: '#fff',
    borderBottom: '1px solid #e8e8e8',
    padding: 12,

    '&>*': {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
    },

    '&>:last-child': {
        justifyContent: 'end',
    },
})

export default function ToolBar(props) {
    return (
        <div
            css={cssToolBar}
            {...props}
        >
        </div>
    )
}
